module.exports = __webpack_public_path__ + "img/fast-food.bd1bd477.png";